import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const pinkMoon: ProjectContentData = {
  id: 'pink-moon',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'token-details',
      label: 'Token Details',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'Arbitrum',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: '$PIMS',
          value: '$PIMS',
          name: 'Token Ticker',
          description: <span>Symbol of Token.</span>,
        },
        {
          id: 'total-supply',
          value: '100,000,000',
          name: 'Total Supply',
          description: (
            <span>
              Displays the total token
              <br />
              supply.
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '3,475,000',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating
              <br />
              supply at TGE.
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$695,000',
          name: 'Initial Market Cap',
          description: (
            <span>
              Shows the initial market
              <br />
              cap at TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$200,000',
          description: (
            <span>
              Total funds aimed to be
              <br />
              raised in this token sale.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.1',
          description: (
            <span>
              Token price during the
              <br />
              sale.
            </span>
          ),
        },
        {
          id: 'deposit-method',
          name: 'Deposit Method',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The token in which you
              <br />
              will be able to deposit in
              <br />
              this token sale
            </span>
          ),
        },
        {
          id: 'claim-method',
          name: 'Refund Policy',
          value: '3-days',
          description: (
            <span>
              The amount of days you
              <br />
              can request a refund
              <br />
              {`after TGE if you didn't`}
              <br />
              claim any tokens yet
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '15%',
          name: 'At TGE',
          description: (
            <span>
              The first token claim will
              <br />
              be available 2 hours
              <br />
              after the TGE
              <br />
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '0 months',
          name: 'Cliff',
          description: (
            <span>
              The amount of months
              <br />
              from TGE until your next
              <br />
              unlock
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '6 months',
          name: 'Linear Vesting',
          description: (
            <span>
              The amount of months in
              <br />
              which the rest of your
              <br />
              tokens will be unlocked
              <br />
              over time on a daily
              <br />
              basis
            </span>
          ),
        },
        {
          id: 'magic-launchpad',
          value: 'Magic Launchpad',
          name: 'Claim Method',
          description: (
            <span>
              Tokens can be claimed
              <br />
              via the Magic Launchpad
              <br />
              Dashboard.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido-schedule',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'whitelist-campaign-start',
          value: '11.11.2024',
          name: 'Whitelist Campaign Start',
          description: (
            <span>
              Complete the whitelist campaign to join the Public Pool; Magic Members enjoy
              <br />
              exclusive access to a separate pool
              <br />
              without whitelist requirements.
            </span>
          ),
        },
        {
          id: 'sale-start',
          value: '03.12.2024',
          name: 'Sale Start',
          description: <span>Start date of the Token Sale.</span>,
        },
        {
          id: 'sale-end',
          value: '05.12.2024',
          name: 'Sale End',
          description: <span>End date of the Token Sale.</span>,
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'TBD',
          description: (
            <span>
              Token exchange listing
              <br />
              date and time.
            </span>
          ),
        },
      ],
    },
  ],
};
